import { render, staticRenderFns } from "./ClockDashIcon.vue?vue&type=template&id=60955d89&"
import script from "./ClockDashIcon.vue?vue&type=script&lang=js&"
export * from "./ClockDashIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports